import * as React from "react";
import { useCustomChatContext, useUserId } from "../UserProvider";
import { usePlayerProfile } from "../PlayerProfile";
import { ErrorBoundary } from "../ErrorBoundary";

const ChatComponent = React.lazy(() => import("./Chat"));

export const Chat = () => {
  const userId = useUserId();
  const showProfile = usePlayerProfile();
  const onProfileClick = React.useCallback(
    (profile: { id: string; name: string }) => {
      //@ts-ignore
      showProfile({ ...profile });
      return true;
    },
    [showProfile]
  );

  const { openedChat } = useCustomChatContext();

  return (
    <>
      {openedChat && (
        <ErrorBoundary fallback={null}>
          <React.Suspense fallback={null}>
            <ChatComponent
              //@ts-ignore
              onChat={""}
              messages={null}
              currentUserId={userId}
              disabled={false}
              onProfileClick={onProfileClick}
            />
          </React.Suspense>
        </ErrorBoundary>
      )}
    </>
  );
};

export * from "./types";
